import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import useWallet from './useWallet';
import useQueryParams from './useQueryParams';

// import removeQueryParam from 'lib/router/removeQueryParam';
// import updateQueryParam from 'lib/router/updateQueryParam';

export default function useAutoConnectWallet() {
  const $ = _c(10);
  const {
    isWalletConnected,
    isModalOpen,
    connect
  } = useWallet();
  const isConnectionStarted = useRef(false);
  const {
    queryParams,
    setQueryParams
  } = useQueryParams();
  let t0;
  if ($[0] !== connect || $[1] !== isModalOpen || $[2] !== isWalletConnected || $[3] !== queryParams.action || $[4] !== setQueryParams) {
    t0 = () => {
      if (queryParams.action !== "connect") {
        return;
      }
      let timer;
      if (!isWalletConnected && !isModalOpen) {
        if (!isConnectionStarted.current) {
          timer = setTimeout(() => {
            if (!isWalletConnected) {
              connect();
              isConnectionStarted.current = true;
            }
          }, 500);
        } else {
          isConnectionStarted.current = false;
          setQueryParams({
            action: "tooltip"
          });
        }
      } else {
        if (isWalletConnected) {
          isConnectionStarted.current = false;
          setQueryParams({
            action: ""
          });
        }
      }
      return () => clearTimeout(timer);
    };
    $[0] = connect;
    $[1] = isModalOpen;
    $[2] = isWalletConnected;
    $[3] = queryParams.action;
    $[4] = setQueryParams;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== connect || $[7] !== isModalOpen || $[8] !== isWalletConnected) {
    t1 = [isWalletConnected, isModalOpen, connect];
    $[6] = connect;
    $[7] = isModalOpen;
    $[8] = isWalletConnected;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  useEffect(t0, t1);
}